module.exports = __webpack_public_path__ + "img/icon-atras.34dd5c47.svg";